import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaCheck, FaEdit, FaTimes } from "react-icons/fa";
import { useU2000AuthContext } from "../../../u2000Core/context/auth/U2000UseAuthContext";
import { NS, U3130ROLES } from "../../U3130";
import type { U3130Timesheet } from "../../U3130TimesheetModel";

interface U3130TimesheetDetailToolBarProps {
  data: U3130Timesheet | null;
  onModifyClick: () => void;
  onApproveClick: () => void;
  onRefuseClick: () => void;
  modifyLoading: boolean;
  approveLoading: boolean;
  refuseLoading: boolean;
}

const U3130TimesheetDetailToolBar: React.FC<U3130TimesheetDetailToolBarProps> = ({
  data,
  onModifyClick,
  onApproveClick,
  onRefuseClick,
  modifyLoading,
  approveLoading,
  refuseLoading,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useU2000AuthContext();
  const canEdit = hasRole(U3130ROLES.EDIT);
  const isWaiting = data?.status === "WaitingForApproval";
  const busy = modifyLoading || approveLoading || refuseLoading;

  /** Alignement visuel avec U3129TimesheetFormToolBar (Fermer / Réouvrir : contour, pas de bouton « retour » texte — retour liste via U2000FormNavigationActions). */
  const actions = [
    {
      key: "modify",
      label: modifyLoading ? t("btnModifyPending", { ns: NS }) : t("btnModify", { ns: NS }),
      hasRole: canEdit && isWaiting,
      handleClick: onModifyClick,
      icon: FaEdit,
      Component: U2000ActionBtn,
      disabled: busy,
      className: "bg-white! text-blue-700! border! border-blue-300! hover:bg-blue-50! hover:shadow-none! focus:ring-blue-500!",
    },
    {
      key: "refuse",
      label: refuseLoading ? t("btnRefusePending", { ns: NS }) : t("btnRefuse", { ns: NS }),
      hasRole: canEdit && isWaiting,
      handleClick: onRefuseClick,
      icon: FaTimes,
      Component: U2000ActionBtn,
      disabled: busy,
      className: "bg-white! text-amber-700! border! border-amber-300! hover:bg-amber-50! hover:shadow-none! focus:ring-amber-500!",
    },
    {
      key: "approve",
      label: approveLoading ? t("btnApprovePending", { ns: NS }) : t("btnApprove", { ns: NS }),
      hasRole: canEdit && isWaiting,
      handleClick: onApproveClick,
      icon: FaCheck,
      Component: U2000ActionBtn,
      disabled: busy,
      className: "bg-white! text-green-700! border! border-green-300! hover:bg-green-50! hover:shadow-none! focus:ring-green-500!",
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};

export default U3130TimesheetDetailToolBar;
